<script setup>
import Button from "@/Components/Buttons/Button.vue";
</script>

<template>
    <Button
        class="bg-white border border-theme-primary text-theme-primary hover:brightness-90 transition-all duration-300"
    >
        <slot />
    </Button>
</template>

<style scoped></style>
